import { forwardRef, type HTMLAttributes } from 'react';
import cn from 'classnames';

import { Picture } from '@/components/ui/Picture/Picture';

import { Tile } from '../Tile/Tile';
import { TilesBg } from '../TilesBg/TilesBg';

import cashPng from '/img/icons/cash-large.png';
import cashWebp from '/img/icons/cash-large.webp';

interface CashTileProps extends HTMLAttributes<HTMLDivElement> {
  isActive?: boolean;
}

const CashTile = forwardRef<HTMLDivElement, CashTileProps>((props, ref) => {
  return (
    <Tile
      ref={ref}
      {...props}
      variant={props.isActive ? 'dark' : 'grey'}
      className={cn(props.className, 'flex items-center justify-center')}
    >
      <Picture
        className="relative z-[2] w-[80%] h-[80%]"
        img={cashPng}
        webp={cashWebp}
        alt="cash"
      />
      {props.isActive && <TilesBg variant="green-active" />}
    </Tile>
  );
});

export { CashTile };
